import { Model } from "@/models/index";
import Initiative from "@/models/Initiative";
import Tag from "@/models/Tag";

export default class InitiativeTag extends Model {
  static type = "initiativeTags";
  initiative!: Initiative;
  tag!: Tag;
}
